<div class="header-bar">
  <div class="header-left">
    <div class="header-text">{{ previewTitle }}</div>
  </div>
</div>

<div class="documents-preview">
  <div class="content" *ngIf="!loading">
    <div *ngIf="categoriesData.length === 0" class="no-data">
      No categories or tags found.
    </div>

    <div *ngFor="let category of categoriesData" class="category-item">
      <div class="category-header">
        <h3 class="category-name">{{ category.document_category_name }}</h3>
        <span class="category-id">ID: {{ category.document_category_id }}</span>
      </div>
      
      <div class="tags-section">
        <div class="tags-label">Tags:</div>
        <div class="tags-container">
          <span *ngIf="category.distinct_tags.length === 0" class="no-tags">No tags</span>
          <span 
            *ngFor="let tag of category.distinct_tags" 
            class="tag-chip"
          >
            {{ tag }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="content loading-container" *ngIf="loading">
    <div class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
      <div class="loading-text">Loading categories and tags...</div>
    </div>
  </div>
</div> 